export default "__VITE_ASSET__F4SrjxqQ__"